export default __webpack_public_path__ + "assets/mobileImage.dfc7bd90.png";